import {
   Card,
   Flex,
   Text,
   Button,
   Box,
   Input,
   Select,
   useColorModeValue,
   useBreakpointValue,
   useOutsideClick,
   useDisclosure,
   Spinner,
   Center,
   useColorMode,
} from '@chakra-ui/react';
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import SalesSingleDataView from '../../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';
import WarehouseForm from './warehouseForm';

// UI
import Menu from 'components/menu/MainMenu';
import DynamicDataTable from '../../../masters/components/DynamicDataTable';

import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import { SearchIcon } from '@chakra-ui/icons';

import { useFilterData, downloadPDF, downloadExcel } from '../../../../../utils/DataTableUtils';
import { deleteRecord } from '../../../../../utils/util';
import SalesDetails from 'components/salesDetails/SalesDetails';
import TransactionDetailModal from 'views/admin/masters/components/TransactionDetailModel';

// ACTION
import {
   getPurchaseInvoice,
   getPurchaseInvoices,
   deletePurchaseInvoice,
   emptyPurchase,
   getSinglePurchaseWithPrevAndNext,
   updateSyncPurchaseInvoice,
} from '../../../../../redux/actions/purchaseInvoice';
import { getAccountById } from '../../../../../redux/actions/account';

import {
   getStockTransfer,
   addStockTransfer,
   updateStockTransfer,
   deleteStockTransfer,
   getStockTransferLastDoc,
   getStockTransferById,
} from '../../../../../redux/actions/stocktransfer';

import { useDispatch } from 'react-redux';
import { useUser, useGlobal } from 'contexts';
import SalesInvoiceFilterModal from 'views/admin/sales/Pages/SalesInvoiceMaster/SalesInvoiceFilterModal';
import { IoFilterOutline } from 'react-icons/io5';
import { AiTwotoneBook } from 'react-icons/ai';
import { IoMdArrowRoundBack } from 'react-icons/io';
import Loader from 'views/admin/default/Loader';

const columnHelper = createColumnHelper();
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const StockTransferMaster = () => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const backgroundColor = useColorModeValue('#ffffff', 'rgba(12, 20, 41, 1)');
   const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const { user } = useUser();
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [iswarehouse, setIswarehouse] = useState(false);
   const [isEditMode, setIsEditMode] = useState(false);
   const [isEditData, setIsEditData] = useState({});
   const {
      isOpen: isBillToBillModal,
      onOpen: onOpenBillToBillModal,
      onClose: onCloseBillToBillModal,
   } = useDisclosure();
   const stocktransfer = useSelector((state) => state.stocktransfer?.list || []);
   const Totals = useSelector((state) => state.stocktransfer.pagination.totals);
   const isLoading = useSelector((state) => state.stocktransfer.isLoading);
   const pagination = useSelector((state) => state.stocktransfer?.pagination);
   const totalCount = useSelector((state) => state.stocktransfer?.totalCount);
   const singleEntity = useSelector((state) => state?.stocktransfer?.single || {});
   const viewData = useSelector((state) => state?.stocktransfer?.purchaseData);
   const account = useSelector((state) => state.account.single);
   const [currentPage, setCurrentPage] = useState(1);
   const [limit, setLimit] = useState(10);
   const [data, setData] = useState([]);
   const [isEditingPage, setIsEditingPage] = useState(false);
   const [pageInputValue, setPageInputValue] = useState('');
   const [searchQuery, setSearchQuery] = useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
   const [expanded, setExpanded] = useState(false);
   const [isOpenSingleView, setIsOpenSingleView] = useState(false);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isDropdownOpen, setDropdownOpen] = useState(false);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [paginateData, setPaginateData] = useState({});
   const [isDataLoading, setIsDataLoading] = useState(false); // New comprehensive loading state
   const [isSearching, setIsSearching] = useState(false);
   const [isFiltering, setIsFiltering] = useState(false);
   const [isInitialLoad, setIsInitialLoad] = useState(true);
   const Admin = user?.isAdmin;
   const [accountId, setAccountId] = useState(null);
   const [companyId, setCompanyId] = useState(null);
   const [invoiceData, setInvoiceData] = useState(null);
   const StockTransferRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === user?.loginhistory?.companyId)?.inventorystocktransfer
      : null;

   const { viewDetail, paginate } = useMemo(() => {
      const data = viewData?.data[0];
      const pagination = viewData?.pagination;
      return { viewDetail: data, paginate: pagination };
   }, [viewData?.data, viewData?.pagination]);

   const [columnVisibility, setColumnVisibility] = useState({
      docno: true,
      transactionAt: true,
      fromWarehouseName: true,
      toWarehouseName: true,
      itemname: true,
      netAmount: true,
      createdU: false,
      updatedU: false,
      status: false,
      action: true,
   });
   const [sorting, setSorting] = useState([]);

   const columnsData = useMemo(
      () => [
         { id: 'docno', header: 'DOC NO', accessor: 'docno' },
         { id: 'transactionAt', header: 'DOC Date', accessor: 'transactionAt' },
         { id: 'fromWarehouseName', header: 'From Warehouse', accessor: 'fromWarehouseName' },
         { id: 'toWarehouseName', header: 'To Warehouse', accessor: 'toWarehouseName' },
         { id: 'itemname', header: 'Item Name', accessor: 'itemname' },
         {
            id: 'netAmount',
            header: (
               <Box>
                  <Text>Net Amount</Text>
                  {Totals?.totalNetAmount > 0 && (
                     <Text fontSize="xs" color="gray.500" display="inline-flex" alignItems="baseline">
                        (₹{' '}
                        {
                           Totals.totalNetAmount
                              .toLocaleString('en-IN', {
                                 minimumFractionDigits: 2,
                                 maximumFractionDigits: 2,
                              })
                              .split('.')[0]
                        }
                        <Text as="span" fontSize="0.8em" verticalAlign="baseline">
                           .{Totals.totalNetAmount.toFixed(2).split('.')[1]}
                        </Text>
                        )
                     </Text>
                  )}
               </Box>
            ),
            accessor: 'netAmount',
         },
         { id: 'createdU', header: 'Created By', accessor: 'createdU' },
         { id: 'updatedU', header: 'Updated By', accessor: 'updatedU' },
         { id: 'status', header: 'STATUS', accessor: 'status' },
      ],
      [Totals],
   );
   const [filters, setFilters] = useState({
      pendingstatus: 'all',
      invoiceBook: 'all',
      duration: 'any',
      contact: '',
      item: '',
      daybookId: '',
      daybookIds: '',
      accountIds: '',
      accountId: '',
      fromDate: '',
      toDate: '',
   });

   // Comprehensive loading state that covers all scenarios
   const shouldShowLoader = useMemo(() => {
      return isDataLoading || isInitialLoad || isSearching || isFiltering || isLoading;
   }, [isDataLoading, isInitialLoad, isSearching, isFiltering, isLoading]);

   const handleApplyFilters = async (newFilters) => {
      setIsDataLoading(true);
      setIsFiltering(true);
      setFilters(newFilters);
      setCurrentPage(1);

      try {
         const sortBy = sorting.length > 0 ? sorting[0]?.id : 'id';
         const sortOrder = sorting.length > 0 ? (sorting[0]?.desc ? 'DESC' : 'ASC') : 'DESC';

         await dispatch(
            getStockTransfer({
               page: 1,
               // limit: limit,
               search: debouncedSearchQuery,
               companyId: user?.loginhistory?.companyId,
               sortBy,
               sortOrder,
            }),
         );
      } catch (error) {
         console.error('Error applying filters:', error);
      } finally {
         setIsDataLoading(false);
         setIsFiltering(false);
      }
   };

   const columns = columnsData
      .filter((column) => columnVisibility[column.id])
      ?.map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   const table = useReactTable({
      data,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const wrapperRef = useRef();

   const filteredData = useFilterData(data, debouncedSearchQuery, columns);

   const handlePageChange = useCallback(
      (directionOrPage) => {
         if (typeof directionOrPage === 'number') {
            setCurrentPage(directionOrPage);
         } else {
            setCurrentPage((prevPage) => {
               if (directionOrPage === 'next') {
                  return prevPage < pagination?.totalPages ? prevPage + 1 : prevPage;
               } else {
                  return prevPage > 1 ? prevPage - 1 : prevPage;
               }
            });
         }
      },
      [pagination?.totalPages],
   );

   const handlePageClick = () => {
      setIsEditingPage(true);
      setPageInputValue(''); // Clear input value when starting to edit
   };

   const handlePageInputSubmit = () => {
      const page = parseInt(pageInputValue);
      if (!isNaN(page) && page >= 1 && page <= pagination?.totalPages) {
         handlePageChange(page);
      }
      setIsEditingPage(false);
      setPageInputValue('');
   };

   const handlePageInputBlur = () => {
      handlePageInputSubmit();
   };

   const handlePageKeyDown = (e) => {
      if (e.key === 'Enter') {
         handlePageInputSubmit();
      } else if (e.key === 'Escape') {
         setIsEditingPage(false);
         setPageInputValue('');
      }
   };
   const { userGlobalSettingsData } = useGlobal();

   const deletePurchase = () => {
      deleteRecord(viewDetail?.id, deleteStockTransfer, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      onClose();
   };
   const handleViewSingleData = async (id) => {
      await dispatch(getPurchaseInvoice(id));
      setIsOpenSingleView(true);

      const currentIdx = stocktransfer.findIndex((x) => x.id === id);
      const prevObject = currentIdx > 0 ? stocktransfer[currentIdx - 1] : null;
      const nextObject = currentIdx < stocktransfer.length - 1 ? stocktransfer[currentIdx + 1] : null;

      await dispatch(
         getSinglePurchaseWithPrevAndNext({
            id: id,
            page: 1,
            limit: 1,
            sortBy: 'id',
            sortOrder: 'desc',
         }),
      );
      setPaginateData({
         hasPreviousPage: prevObject ? true : false,
         previousPage: prevObject ? currentIdx - 1 : null,
         nextPage: nextObject ? currentIdx + 1 : null,
         hasNextPage: nextObject ? true : false,
      });
      onOpen();
   };

   const handlePrevPage = useCallback(
      async (page) => {
         await dispatch(
            getSinglePurchaseWithPrevAndNext({
               page: page,
               limit: 1,
               sortBy: 'id',
               sortOrder: 'desc',
            }),
         );
      },
      [dispatch],
   );
   const handleNextPage = useCallback(
      async (page) => {
         await dispatch(
            getSinglePurchaseWithPrevAndNext({
               page: page,
               limit: 1,
               sortBy: 'id',
               sortOrder: 'desc',
            }),
         );
      },
      [dispatch],
   );

   const toggleDropdown = () => {
      setDropdownOpen(!isDropdownOpen);
   };

   const handleOnClose = useCallback(() => {
      dispatch(emptyPurchase());
      onClose(true);
   }, [dispatch, onClose]);

   const handleOnCloseBillToBill = useCallback(() => {
      setAccountId(null);
      setCompanyId(null);
      onCloseBillToBillModal();
   }, [onCloseBillToBillModal]);

   const getStockTransferData = useCallback(async () => {
      if (user && user?.loginhistory?.companyId) {
         setIsDataLoading(true);
         let sortBy = sorting.length > 0 ? sorting[0]?.id : 'id';
         let sortOrder = sorting.length > 0 ? (sorting[0]?.desc ? 'DESC' : 'ASC') : 'DESC';
         try {
            await dispatch(
               getStockTransfer({
                  page: currentPage,
                  // limit: limit,
                  search: debouncedSearchQuery,
                  companyId: user?.loginhistory?.companyId,
                  sortBy,
                  sortOrder,
               }),
            );
         } catch (error) {
            console.error('Error fetching stock transfer data:', error);
         } finally {
            setIsDataLoading(false);
            setIsInitialLoad(false);
            setIsSearching(false);
            setIsFiltering(false);
         }
      }
   }, [currentPage, dispatch, limit, debouncedSearchQuery, sorting, user]);

   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (debouncedSearchQuery === '') setExpanded(false);
      },
   });

   useEffect(() => {
      getStockTransferData();
   }, [getStockTransferData]);

   useEffect(() => {
      const admin = user?.isAdmin;
      const rights = user?.userRights?.find((ur) => ur?.companyId === user?.loginhistory?.companyId);
      if (user && !user?.packageData?.[0]?.stock_transfer && !(admin || rights?.inventorystocktransfer?.view)) {
         window.history.back();
      }
   }, [user]);


   useEffect(() => {
      if (account) {
         const details = [
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ];
         setDynamicUserDetails(details);
      }
   }, [account]);

   useEffect(() => {
      if (isOpenSingleView) {
         // dispatch(getAccountById({ id: singleEntity?.accountId, compId: user?.loginhistory?.companyId }));
      }
   }, [dispatch, isOpenSingleView, singleEntity?.accountId, user?.loginhistory?.companyId]);

   useEffect(() => {
      setPaginateData(paginate);
   }, [paginate]);

   useEffect(() => {
      setData(stocktransfer);
      return () => { };
   }, [stocktransfer]);

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };

   const debouncedSearchHandler = React.useCallback(
      debounce((query) => {
         setDebouncedSearchQuery(query);
         setIsSearching(true);
         setCurrentPage(1);
      }, 500),
      [],
   );

   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchQuery(value);
      debouncedSearchHandler(value);
   };

   const handleCloseModals = async () => {
      setIswarehouse(false);
      setIsDataLoading(true);
      let sortBy = sorting.length > 0 ? sorting[0]?.id : 'id';
      let sortOrder = sorting.length > 0 ? (sorting[0]?.desc ? 'DESC' : 'ASC') : 'DESC';
      try {
         await dispatch(
            getStockTransfer({
               page: currentPage,
               limit: limit,
               search: debouncedSearchQuery,
               companyId: user?.loginhistory?.companyId,
               sortBy,
               sortOrder,
            }),
         );
      } catch (error) {
         console.error('Error refreshing stock transfer data:', error);
      } finally {
         setIsDataLoading(false);
      }
   };

   const handlewarehouseForm = () => {
      // Implementation for handling merge code form
   };

   const handleaddedit = () => {
      setIsEditData(null);
      setIsEditMode(false);
      setIswarehouse(true);
   };

   return (
      <>
         <Card
            flexDirection="column"
            w="100%"
            px="0px"
            overflowX={{ sm: 'scroll', lg: 'hidden' }}
            position="relative"
            py="10px"
            mt="2%"
            bg={backgroundColor}>
            <Flex
               width={{ base: '100%', md: 'auto' }}
               mb="8px"
               px={{ base: '1px', md: '25px' }}
               justifyContent="space-between"
               align="center"
               overflowX="auto"
               flexWrap="nowrap"
               gap={3}>
               <Flex align="center" gap={4} flexShrink={0}>
                  <Text
                     color={textColor}
                     ml={{ base: '8px', md: 0 }}
                     fontSize={{ base: '17px', lg: '22px' }}
                     fontWeight="700"
                     lineHeight="100%">
                     Stock Transfer
                  </Text>
               </Flex>

               <Flex align="center" gap={2} flexShrink={0} p={3}>
                  {!user?.isExpired && (
                     <button
                        onClick={handleaddedit}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                           }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${isDark ? 'via-cyan-100/20' : 'via-white/30'
                              }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${isDark ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30' : 'bg-white/20 group-hover:bg-white/30'
                              }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  )}
                  {/* <Box cursor={'pointer'} onClick={onFilterOpen}>
                     <IoFilterOutline size={22} />
                  </Box>
                  <Box cursor={'pointer'} onClick={() => navigate('/admin/purchase/invoice/managedaybook')}>
                     <AiTwotoneBook size={22} />
                  </Box> */}
                  {/* Pagination Controls */}
                  <Flex align="center" flexShrink={0}>
                     <Box
                        onClick={() => handlePageChange('prev')}
                        cursor={currentPage > 1 ? 'pointer' : 'not-allowed'}
                        opacity={currentPage > 1 ? 1 : 0.5}
                        role="button"
                        aria-label="Previous page">
                        <MdNavigateBefore size={28} />
                     </Box>

                     {/* Current Page Display with Manual Input */}
                     <Flex align="center" mx="10px" position="relative">
                        {!isEditingPage ? (
                           <Flex align="center">
                              <Text
                                 as="span"
                                 fontSize={{ base: '14px', lg: '17px' }}
                                 minWidth="40px"
                                 textAlign="center"
                                 onClick={handlePageClick}
                                 cursor="pointer"
                                 border="2px solid"
                                 borderColor="blue.500"
                                 color="blue.600"
                                 fontWeight="medium"
                                 px={2}
                                 py={1}
                                 borderRadius="md"
                                 _hover={{ bg: 'blue.50' }}>
                                 {currentPage}
                              </Text>
                              <Text as="span" fontSize={{ base: '14px', lg: '17px' }} mx={1}>
                                 /
                              </Text>
                              <Text as="span" fontSize={{ base: '14px', lg: '17px' }}>
                                 {pagination?.totalPages || 1}
                              </Text>
                           </Flex>
                        ) : (
                           <Flex align="center">
                              <Input
                                 type="number"
                                 min={1}
                                 max={pagination?.totalPages || 1}
                                 value={pageInputValue}
                                 onChange={(e) => setPageInputValue(e.target.value)}
                                 onBlur={handlePageInputBlur}
                                 onKeyDown={handlePageKeyDown}
                                 fontSize={{ base: '14px', lg: '17px' }}
                                 width="40px"
                                 textAlign="center"
                                 p={0}
                                 border="2px solid"
                                 borderColor="blue.500"
                                 _focus={{ outline: 'none', ring: '1px', ringColor: 'blue.500' }}
                                 autoFocus
                              />
                              <Text as="span" fontSize={{ base: '14px', lg: '17px' }} mx={1}>
                                 /
                              </Text>
                              <Text as="span" fontSize={{ base: '14px', lg: '17px' }}>
                                 {pagination?.totalPages || 1}
                              </Text>
                           </Flex>
                        )}
                     </Flex>

                     {/* Next Page Button */}
                     <Box
                        onClick={() => handlePageChange('next')}
                        cursor={currentPage < (pagination?.totalPages || 1) ? 'pointer' : 'not-allowed'}
                        opacity={currentPage < (pagination?.totalPages || 1) ? 1 : 0.5}
                        role="button"
                        aria-label="Next page">
                        <MdNavigateNext size={28} />
                     </Box>
                  </Flex>

                  {/* Page Size Select */}
                  <Select
                     width="auto"
                     h={{ base: 9, lg: 10 }}
                     marginRight="5"
                     value={limit === pagination?.totalProducts ? 'ALL' : limit.toString()}
                     onChange={(e) => {
                        const newLimit = e.target.value === 'ALL' ? totalCount : Number(e.target.value);
                        setLimit(newLimit);
                        setCurrentPage(1); // Reset to first page when changing page size
                     }}>
                     <option value="10">10</option>
                     <option value="20">20</option>
                     <option value="30">30</option>
                     <option value="ALL">All</option>
                  </Select>

                  {/* Search Field */}
                  <MotionFlex
                     ref={wrapperRef}
                     align="center"
                     bg={bg}
                     borderRadius="full"
                     cursor="pointer"
                     px={expanded ? 3 : 0}
                     w={expanded ? '200px' : '40px'}
                     h="40px"
                     transition="all 0.3s ease"
                     onClick={() => setExpanded(true)}>
                     <MotionSearchIcon
                        color={icon}
                        animate={{ rotate: expanded ? 0 : 90 }}
                        transition={{ duration: 0.3 }}
                        style={{ marginRight: expanded ? '8px' : '10px', marginLeft: expanded ? '0' : '10px' }}
                     />
                     {expanded && (
                        <Input
                           variant="unstyled"
                           placeholder="Search..."
                           color={icon}
                           value={searchQuery}
                           onChange={handleSearchChange}
                           autoFocus
                        />
                     )}
                  </MotionFlex>
               </Flex>

               {isMobileOrTablet && (Admin || StockTransferRight?.add) && (!user.isExpired) && (
                  <Box position="fixed" bottom="4" right="4" zIndex={999}>
                     <button
                        onClick={() => navigate('/admin/purchase/invoice/add')}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                           }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${isDark ? 'via-cyan-100/20' : 'via-white/30'
                              }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${isDark
                              ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                              : 'bg-white/20 group-hover:bg-white/30'
                              }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  </Box>
               )}
            </Flex>

            {/* Comprehensive Loader */}
            {shouldShowLoader ? (
               <Loader />
            ) : (
               <DynamicDataTable
                  singleEntityRights={StockTransferRight}
                  table={table}
                  tableData={data}
                  columnsData={columns}
                  emptyMessage="No Stock Transfer data found"
                  handleViewSingleData={() => console.log('')}
                  toggleDropdown={toggleDropdown}
                  onEditClick={(row) => {
                     setIsEditData(row);
                     setIsEditMode(true);
                     setIswarehouse(true);
                  }}
                  onDeleteClick={(id) => {
                     deleteRecord(id, deleteStockTransfer, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
                  }}
                  // onBillToBillClick={(row) => {
                  //    setAccountId(row.accountId);
                  //    setCompanyId(row.companyId);
                  //    setInvoiceData(row);
                  //    onOpenBillToBillModal();
                  // }}
                  canDelete={true}
                  columnVisibility={columnVisibility}
                  totalCount={pagination.total}
               />
            )}
         </Card>

         <SalesDetails
            isOpen={isOpen}
            onClose={handleOnClose}
            singleEntityRights={StockTransferRight}
            title="Purchase Invoice"
            entityType="purchaseinvoice"
            singleEntity={singleEntity}
            setIsEditFormOpen={setIsEditFormOpen}
            setIsOpenSingleView={setIsOpenSingleView}
            isEditFormOpen={isEditFormOpen}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            paginate={paginateData}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            billTerms={viewDetail?.purchasebillteams}
            onDelete={deletePurchase}
            handleSerchClose={() => console.log('')}
         />

         {/* Filter Modal */}
         <SalesInvoiceFilterModal
            entityType="purchaseinvoice"
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            onApplyFilters={handleApplyFilters}
            initialFilters={filters}
            Totals={Totals}
         />
         <TransactionDetailModal
            isOpen={isBillToBillModal}
            onClose={handleOnCloseBillToBill}
            accountId={accountId}
            companyId={companyId}
            invoiceData={invoiceData}
            type="PURCHASE"
            page={currentPage}
            limit={limit}
         />

         <WarehouseForm
            isMergeCode={iswarehouse}
            onClose={handleCloseModals}
            handlewarehouseForm={handlewarehouseForm}
            isEditMode={isEditMode}
            isEditData={isEditData}
         />
      </>
   );
};

export default StockTransferMaster;
